"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentsModelCSSAssets = exports.getComponentsModelJSAssets = exports.filterComponentsModelCSSAssets = exports.filterComponentsModelJSAssets = exports.getComponentsAssets = exports.getComponentAssetsOrder = void 0;
function getComponentAssetsOrder(assets) {
    return [
        ...assets.filter(asset => asset.dependency),
        ...assets.filter(asset => !asset.dependency),
    ];
}
exports.getComponentAssetsOrder = getComponentAssetsOrder;
function getComponentsAssets(loaders, componentNames) {
    return componentNames.reduce((acc, componentName) => {
        /**
         * check if asset's url was already added
         * for cases when components are loaded within batch
         */
        const componentAssets = loaders[componentName].assets.filter(asset => !acc.find(existingAsset => existingAsset.url === asset.url));
        return [...acc, ...componentAssets];
    }, []);
}
exports.getComponentsAssets = getComponentsAssets;
function filterComponentsModelJSAssets(assets) {
    return assets.filter(asset => asset.type === 'model');
}
exports.filterComponentsModelJSAssets = filterComponentsModelJSAssets;
function filterComponentsModelCSSAssets(assets) {
    return assets.filter(asset => asset.type === 'style');
}
exports.filterComponentsModelCSSAssets = filterComponentsModelCSSAssets;
function getComponentsModelJSAssets(loaders, componentNames) {
    return getComponentAssetsOrder(filterComponentsModelJSAssets(getComponentsAssets(loaders, componentNames)));
}
exports.getComponentsModelJSAssets = getComponentsModelJSAssets;
function getComponentsModelCSSAssets(loaders, componentNames) {
    return getComponentAssetsOrder(filterComponentsModelCSSAssets(getComponentsAssets(loaders, componentNames)));
}
exports.getComponentsModelCSSAssets = getComponentsModelCSSAssets;
//# sourceMappingURL=assets.js.map